import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RadioGroup = _resolveComponent("RadioGroup")!
  const _component_CheckboxGroup = _resolveComponent("CheckboxGroup")!

  return (_openBlock(), _createElementBlock("div", null, [
    ($props.isSingleSelect)
      ? (_openBlock(), _createBlock(_component_RadioGroup, {
          key: 0,
          slug: $props.slug,
          description: $props.description,
          isSmallLabel: $props.isSmallLabel,
          filterValues: $props.filterValues,
          label: $props.title,
          showNumResults: true,
          onRadioChange: $options.onFilterChange
        }, null, 8 /* PROPS */, ["slug", "description", "isSmallLabel", "filterValues", "label", "onRadioChange"]))
      : (_openBlock(), _createBlock(_component_CheckboxGroup, {
          key: 1,
          slug: $props.slug,
          isSmallLabel: $props.isSmallLabel,
          description: $props.description,
          filterValues: $props.filterValues,
          label: $props.title,
          showNumResults: true,
          onFilterChange: $options.onFilterChange
        }, null, 8 /* PROPS */, ["slug", "isSmallLabel", "description", "filterValues", "label", "onFilterChange"]))
  ]))
}